import React, { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import logo from "../assets/images/logo.png";
import { useWallet } from "../pages/walletconnect/walletContext";
import Web3 from "web3";
import config from "../config/config";
import { toastAlert } from "../helper/toastAlert";
import { getUserLocation, login } from "../ApiAction/api";
import { useAccount } from "wagmi";
import { useNavigate } from "react-router-dom"


export default function MyNavbar() {
  const { address, isConnected, connectors, connectWallet, disconnectWallet } = useWallet();


  const navigate = useNavigate()


  console.log('address :', address);
  console.log('localStorage.getItem("WinChoToken") :', localStorage.getItem("WinChoToken"));
  useEffect(() => {
    const refCode = localStorage.getItem("referralCode");
    if (address && !localStorage.getItem("WinChoToken")) {
      authLogin(address, refCode);
    } else if (!address) {
      localStorage.removeItem("WinChoToken");
      localStorage.removeItem('wagmi.connected');
      localStorage.removeItem('wagmi.store');
      sessionStorage.removeItem('wagmi.connected');
      sessionStorage.removeItem('wagmi.store');
    }
  }, [address]);

  const authLogin = async (address, refCode) => {
    let datas = {
      userData: { address, refCode },
    };
    let { status, message, success, authToken, errors } = await login(datas);
    console.log('authToken :', authToken);

    if (status === true) {
      toastAlert("success", message, "login");
      localStorage.setItem("WinChoToken", authToken);
      localStorage.setItem("rememberedEmail", address);
      setTimeout(() => {
        window.location.href = "/buytoken";
        // navigate("/buytoken")
      }, 2000);
    }
  }
  const handleDisconnect = async () => {
    try {
      await disconnectWallet(); // wait for wallet disconnection
      localStorage.removeItem("WinChoToken");
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem('wagmi.connected');
      localStorage.removeItem('wagmi.store');
      sessionStorage.removeItem('wagmi.connected');
      sessionStorage.removeItem('wagmi.store');
      toastAlert("success", "Wallet disconnected successfully", "logout");
      setTimeout(() => {
        window.location.href = "/";
      }, 1000)
    } catch (error) {
      toastAlert("error", "Error disconnecting wallet", "logout");
    }
  };

  async function handleConnect(connector) {
    try {
      window.$(".btn-close").click()
      const network = config.chainId;
      const isMobileDevice = isMobile();
      const connectorId = connector?.id || "";

      // Mobile MetaMask SDK
      if (isMobileDevice && !window.ethereum && connectorId === "metaMaskSDK") {
        connectMetamaskMobile();
        return;
      }

      // Initialize web3 depending on connector type
      let web3 = null;
      if (connectorId === "injected") {
        web3 = new Web3(window.BinanceChain);
      } else if (connectorId !== "walletConnect") {
        web3 = new Web3(window.ethereum);
      } else {
        web3 = new Web3(config.rpc[network]);
      }

      // Check current network
      let currNetwork = await web3.eth.net.getId();
      if (parseInt(currNetwork) !== parseInt(network) && connectorId !== "walletConnect") {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: Web3.utils.toHex(network) }],
        });
        currNetwork = network;
      }

      await connectWallet(connector);
      // window.ethereum.accounts[0] = address;
      // await authLogin(address)

      const modalEl = document.getElementById("walletModal");
      if (modalEl && window.bootstrap?.Modal) {
        const modalInstance =
          window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
        modalInstance.hide();
      }

      window.$("#walletModal").modal("hide");
    } catch (err) {
      const errorMsg = err?.message?.toString() || err.toString();
      if (errorMsg.includes("Provider not set or invalid")) {
        toastAlert("error", "Please login into MetaMask", "errormetamask");
      } else if (errorMsg.includes("User rejected")) {
        toastAlert("error", "Confirmation is rejected", "errormetamask");
      } else {
        toastAlert("error", "Please try again later", "errormetamask");
      }
    }
  }
  console.log('localStorage.getItem("rememberedEmail") :', localStorage.getItem("rememberedEmail"));


  const connectMetamaskMobile = () => {
    const currentUrl = window.location.href;

    // Split the URL to get the dapp URL
    const urlParts = currentUrl.split("//");
    if (urlParts.length > 1) {
      const dappUrl = urlParts[1].split("/")[0];
      const metamaskAppDeepLink = "https://metamask.app.link/dapp/" + dappUrl;
      window.open(metamaskAppDeepLink, "_self");
    } else {
      console.error("Invalid URL format");
    }
  };

  function isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  return (
    <><nav className="navbar navbar-expand-md nav_bar">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img src={logo} alt="logo" className="img-fluid" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="offcanvas offcanvas-end nav_offcanva"
          tabIndex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          <div className="offcanvas-header">
            <a className="navbar-brand" href="/">
              <img src={logo} alt="logo" className="img-fluid" />
            </a>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>

          <div className="offcanvas-body">
            <div className="navbar-nav justify-content-end flex-grow-1 pe-3">
              <Nav.Link href="/token" className="primary_btn me-3">
                WIN Token
              </Nav.Link>

              {isConnected && localStorage.getItem("WinChoToken") ? (
                <>
                  <Nav.Link href="/dashboard" className="primary_btn me-3">
                    Dashboard
                  </Nav.Link>
                  <button className="primary_btn me-3" onClick={handleDisconnect}>
                    {localStorage.getItem("rememberedEmail").slice(0, 6)}...{localStorage.getItem("rememberedEmail").slice(-4)}
                  </button>
                </>
              ) : (
                <button
                  className="primary_btn me-3"
                  data-bs-toggle="modal"
                  data-bs-target="#walletModal"
                >
                  Connect Wallet
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>

      {/* Wallet Connect Modal */}
      <div
        className="modal fade model_box"
        id="walletModal"
        tabIndex="-1"
        aria-labelledby="walletModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="walletModalLabel">
                Connect Wallet
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="meta_connect d-flex justify-content-around flex-wrap">
                {connectors.map((connector, i) => {
                  if (connector.name === "MetaMask" || connector.name === "WalletConnect") {
                    return (
                      <div
                        key={i}
                        className="d-flex flex-column align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleConnect(connector)}
                      >
                        <img
                          src={
                            connector.name === "MetaMask"
                              ? require("../assets/images/meta_icon.png")
                              : require("../assets/images/wallet_icon.png")
                          }
                          alt={connector.name}
                          className="img-fluid mb-2"
                          width={50}
                          height={50}
                        />
                        <p className="mb-0">{connector.name}</p>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
